import { render, staticRenderFns } from "./bridgeInventoryForm.vue?vue&type=template&id=e864dd08&scoped=true&"
import script from "./bridgeInventoryForm.vue?vue&type=script&lang=js&"
export * from "./bridgeInventoryForm.vue?vue&type=script&lang=js&"
import style0 from "./bridgeInventoryForm.vue?vue&type=style&index=0&id=e864dd08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e864dd08",
  null
  
)

export default component.exports